<template>
  <VueMarkdown><slot></slot></VueMarkdown>
</template>

<script>
import VueMarkdown from "vue-markdown";

export default {
  name: "Markdown",
  components: {
    VueMarkdown,
  },
};
</script>
